<mat-radio-group
  color="primary"
  [formControl]="surveyConditionalsService.conditionForm$().get('valueToMatch') | toFormControl"
  aria-label="Pick match value on the condition"
  class="conditional__options-list"
>
  @for (option of surveyConditionalsService.options$(); track option.id) {
    <mat-radio-button [value]="option.id" [labelPosition]="'before'" class="conditional__options-list-option">
      @if (option.stimulus?.mediaId) {
        <empathy-shared-stimulus [stimulus]="[option.stimulus]" [readonly]="true" [height]="35" [width]="42"></empathy-shared-stimulus>
      }
      {{ option | optionTextByType: surveyConditionalsService.questionSelected$() }}
    </mat-radio-button>
  }

  @if (surveyConditionalsService.questionSelected$().useOtherInd && surveyConditionalsService.questionSelected$().type !== questionType.RankSort) {
    <mat-radio-button [value]="'OTHER'" [labelPosition]="'before'" class="conditional__options-list-option">
      {{ surveyConditionalsService.questionSelected$().otherLabel | toPlainText }}
    </mat-radio-button>
  }
</mat-radio-group>
